import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarComponent } from '@shared/components/ui/avatar';
import { BadgeComponent } from '@shared/components/ui/badge';
import { IntlDateTimePipe } from '@shared/pipes';
import { heroChangeAnimation } from '@shared/animations';
import type { HeroDisplayType } from '@live-pickup/data-access';

@Component({
  selector: 'lib-live-pickup-hero-section',
  standalone: true,
  imports: [AvatarComponent, BadgeComponent, TranslateModule, IntlDateTimePipe],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.scss',
  animations: [heroChangeAnimation],
})
export class HeroSectionComponent {
  public readonly studentName = input<string>('');
  public readonly personId = input<string>('');
  // TODO(live-pickup): reativar quando o backend enviar StudentClassDisplay.
  // public readonly turma = input<string>('');
  public readonly portao = input<string>('');
  public readonly responsavel = input<string>('');
  public readonly reconhecimentoTime = input<string>('');
  public readonly displayType = input<HeroDisplayType>('recognized');
  public readonly heroId = input<string>('');

  public readonly waitingCount = input<number>(0);
  public readonly completedTodayCount = input<number>(0);
  public readonly avgWaitTime = input<string>('--:--');
  public readonly lastRecognitionTime = input<string>('');

  public readonly isEmpty = computed(() => !this.studentName());
  public readonly firstName = computed(
    () => this.studentName()?.split(' ')[0] ?? '',
  );
  protected readonly lastName = computed(
    () => this.studentName()?.split(' ')[1] ?? '',
  );
  protected readonly formattedWaiting = computed(() =>
    String(this.waitingCount()).padStart(2, '0'),
  );
  protected readonly formattedCompletedToday = computed(() =>
    String(this.completedTodayCount()).padStart(2, '0'),
  );
}
